import React from "react";
import { Layout } from "src/components/layout/Layout";
import { ModuleRouter } from "src/components/molecules";
import { ManagementRoute } from "./management.routes";

export function Configuration() {
  return (
    <Layout>
      {ManagementRoute.subRoutes && (
        <ModuleRouter subRoutes={ManagementRoute.subRoutes} path={ManagementRoute.path} />
      )}
    </Layout>
  );
}
